export const LANDING = '/';
export const BETASIGNEDUP = '/betasignedup';
export const PRIVACY = '/privacy';
